import CommonErrorPage from "./Common/CommonErrorPage";

const Error400 = () => {
  return <CommonErrorPage color="info" page="400" />;
};

export default Error400;
